import { render, staticRenderFns } from "./ChangeSubscription.vue?vue&type=template&id=8772d7d0&scoped=true"
import script from "./ChangeSubscription.vue?vue&type=script&lang=js"
export * from "./ChangeSubscription.vue?vue&type=script&lang=js"
import style0 from "./ChangeSubscription.vue?vue&type=style&index=0&id=8772d7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772d7d0",
  null
  
)

export default component.exports